export const ClientEntityType = {
  Investor: "Investor",
  Account: "Account",
  Fund: "Fund",
  Instrument: "Instrument",
} as const;

export const ClientEntityTypeKeys = Object.keys(ClientEntityType);
